import '../assets/css/bookmarks.css'
import '../assets/css/listinvoices.css'
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom"; // pour permettre d'ajouter un param dans l'url
import Logo from '../assets/img/logo-pinkW.svg';
export function ViewFacture(props) {
    const numberInvoice = useParams().id
    const cutNumberId = numberInvoice.slice(5)
    const cutNumberCodeId = numberInvoice.slice(0, 5)
    const googleSpreadClient = 'https://spreadsheets.google.com/feeds/list/1QreeDxWPsP9s2FzzvygdpYDFRKaPGPFojNfy_RPR4MI/1/public/values?alt=json' // Si les champs sont ok
    const [dataClient, setSetDataClient] = useState([])
    
  
    useEffect(() => {
        fetch(googleSpreadClient)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.feed.entry) {
                        setSetDataClient(result.feed.entry)
                        
                    } else {
                        setSetDataClient('empty')
                    }
                    return
                },
                (error) => {
                    setSetDataClient('error')
                }
            )
        return () => setSetDataClient([])
    }, [])

  
let task = ""
let day = ""
let tjm = ""
let comment = ""
let taskAdd = ""
let dayAdd = ""
let tjmAdd = ""
props.dataDevisFactures
.filter(filtre => filtre.gsx$iddocument.$t.includes(cutNumberId) && filtre.gsx$codeid.$t.includes(cutNumberCodeId))
.map((item) => {
task = item.gsx$taches.$t.split(";")
day = item.gsx$jours.$t.split(";")
tjm = item.gsx$tjm.$t.split(";")
comment = item.gsx$comentairesbytasks.$t.split(";")
taskAdd = item.gsx$tachescomplementaires.$t.split(";")
dayAdd = item.gsx$jourscomplementaires.$t.split(";")
tjmAdd = item.gsx$tjmcomplementaires.$t.split(";")
})
 // Récupération des tâches

 let arrayTasks = []
 for (let i = 0; i < task.length; i++) {
     arrayTasks.push([task[i], comment[i], parseFloat(day[i]),parseFloat(tjm[i])]);
 }
 console.log(arrayTasks)
    // Calc by task add (facture only)
 let arrayTasksAdd = []
    for (let i = 0; i < taskAdd.length; i++) {
        arrayTasksAdd.push([taskAdd[i], parseFloat(dayAdd[i]), parseFloat(tjmAdd[i])]);
    }
    console.log("____________")
    console.log(arrayTasksAdd)
    return (
        <>
            {props.modalView == true ?
                props.dataDevisFactures
                    .filter(filtre => filtre.gsx$iddocument.$t.includes(cutNumberId) && filtre.gsx$codeid.$t.includes(cutNumberCodeId))
                    .map((item) => {
                        return (
                        <main className="modalView">
                            <div className="modal-wrap">
                                <div className="modal-content">
                                    <div className="close-btn" onClick={(e) => {
                                        props.setModalView(false);
                                    }}>×</div>
                                    <header>
                                        <div>
                                            <ul>
                                                <li>8 rue Jeanne Chauvin</li>
                                                <li>77160 Provins</li>
                                                <li>Siret : <strong>808 965 925 00023</strong><br/>NAF : <strong>6201Z</strong></li>
                                            </ul>
                                            <div>
                                                <img src={Logo} alt="Accueil" />
                                                <p className="title"><span>Malika Leroy</span>UI designer & Développeuse front-end freelance</p>
                                            </div>
                                            <ul>
                                                <li><strong>06 43 77 23 09</strong></li>
                                                <li><strong>contact@malikaleroy.fr</strong></li>
                                                <li>www.malikaleroy.fr</li>
                                            </ul>
                                        </div>
                                        <div>
                                        </div>
                                        <div>
                                            <div>
                                                <p>Provins, le {item.gsx$date.$t}</p>
                                                {item.gsx$type.$t === "1 Devis" ? <h1>Votre commande</h1> : null}
                                                {item.gsx$type.$t === "2 Facture d'acompte" ? <h1>Facture d'acompte</h1> : null}
                                                {item.gsx$type.$t === "3 Facture" ? <h1>Facture</h1> : null}
                                                <p><strong>n°{item.gsx$codeid.$t}-{item.gsx$iddocument.$t}</strong></p>
                                            </div>
                                            <div>

                                                {dataClient
                                                    .filter(filtre => filtre.gsx$raisonsociales.$t.includes(item.gsx$client.$t))
                                                    .map((item) => {
                                                        return (
                                                            <ul>
                                                                <li>{item.gsx$raisonsociales.$t}</li>
                                                                <li>{item.gsx$adresse.$t}</li>
                                                                <li>{item.gsx$cp.$t}, {item.gsx$ville.$t}</li>
                                                                <li>{item.gsx$pays.$t}</li>
                                                            </ul>
                                                        )
                                                    })}

                                            </div>
                                        </div>
                                    </header>
                                    <table>
                                        <thead>
                                            <tr>
                                                {item.gsx$type.$t != "2 Facture d'acompte" ?
                                                    <th>Prestations</th> :
                                                    <th>Détail de l'acompte</th>
                                                }
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="detailTache">
                                                <td>
                                            {item.gsx$type.$t === "3 Facture"?
                                            arrayTasks.map((item)=>{return (
                                            <div>{item[0]}</div>
                                            )}):null}

                                            {item.gsx$type.$t === "1 Devis"?
                                            arrayTasks.map((item)=>{return (
                                            <div className={item[1]!=""?"comment":""}>{item[0]}<span>{item[1]!=""?"*":null}</span></div>
                                            )}):null}


                                            

                                            {item.gsx$type.$t === "2 Facture d'acompte"?
                                            <div>Acompte sur la commande n°<strong>{item.gsx$iddevis.$t}</strong></div>
                                            :null}
                                            </td>

                                                


                                                
                                                {item.gsx$type.$t === "1 Devis" || item.gsx$type.$t === "3 Facture" ?
                                                <td>{arrayTasks.map((item)=>{return (<div>{props.formatEUro(item[2]*item[3])}</div>)})}</td>:null}
                                                {item.gsx$type.$t === "2 Facture d'acompte" ?<td>{props.formatEUro(props.calcAcompteHT(item.gsx$jours.$t, item.gsx$tjm.$t ,0,item.gsx$tauxacompte.$t)) }</td>:null}
                                           
                                           
                                            </tr>
                                            {parseFloat(item.gsx$tauxremise.$t)>0&&item.gsx$type.$t === "2 Facture d'acompte" ? 
                                            <tr className="remise">
                                                <td>Remise de {item.gsx$tauxremise.$t}%</td>
                                                <td>{props.formatEUro((props.calcAcompteHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t))-(props.calcAcompteHT(item.gsx$jours.$t, item.gsx$tjm.$t ,0,item.gsx$tauxacompte.$t)))}</td>
                                            </tr>
                                            :null}
                                              {parseFloat(item.gsx$tauxremise.$t)>0&&item.gsx$type.$t==="3 Facture" ? 
                                            <tr className="remise">
                                                <td>Remise de {item.gsx$tauxremise.$t}%</td>
                                                <td>{props.formatEUro((props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t))-(props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, 0))) }</td>
                                            </tr>
                                            :null}
                                               {parseFloat(item.gsx$tauxremise.$t)>0&&item.gsx$type.$t==="1 Devis" ? 
                                            <tr className="remise">
                                                <td>Remise de {item.gsx$tauxremise.$t}%</td>
                                                <td>{props.formatEUro((props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t))-(props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, 0))) }</td>
                                            </tr>
                                            :null}

{parseFloat(item.gsx$tauxremise.$t)&&item.gsx$type.$t==="3 Facture" ? 
                                            <>
                                            <tr className="acompteVerse">
                                                <td>Acompte déjà versé sur la commande n°<strong>{item.gsx$iddevis.$t}</strong></td>
                                                <td>-{props.formatEUro(props.calcAcompteHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t)) }</td>
                                            </tr>
                                            <tr className="soustotal">
                                                <td>Sous total{parseFloat(item.gsx$tauxtva.$t)>0?" HT":null}</td>
                                                <td>{props.formatEUro((props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t)-(props.calcAcompteHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t))))}</td>
                                            </tr>
                                            </>
                                            :null}

                                           


                                            {item.gsx$type.$t === "3 Facture" && item.gsx$tachescomplementaires.$t!=""?
                                            <>
                                            <tr className="tachesCompl">
                                                <td colSpan="2">Interventions supplémentaires</td>
                                            </tr>
                                            <tr className="detailTache">
                                                <td>{arrayTasksAdd.map((item)=>{return (<div>{item[0]}</div>)})}</td>
                                                <td>{arrayTasksAdd.map((item)=>{return (<div>{props.formatEUro(item[1]*item[2])}</div>)})}</td>
                                            </tr>
                                            </>
                                            :null}

{item.gsx$type.$t === "1 Devis"&&
<tr className="prestationComplInfoDevis">
    <td colSpan="2">
        <span>Interventions supplémentaires</span>
        <span>Seront indiquées ici toutes demandes de modifications dépassants le cadre de cette commande. Tarif indicatif : 65 € / heure</span>
    </td>
</tr>
 }


                                        </tbody>
                                        <tfoot>
                                        
                                        <tr>
                                            <th>Total{parseFloat(item.gsx$tauxtva.$t)>0?" HT":null}</th>
                                            <td>
                                                {item.gsx$type.$t === "1 Devis" && item.gsx$jours.$t.length > 0 ? props.formatEUro(props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t)) : null}
                                                {item.gsx$type.$t === "3 Facture" && item.gsx$jours.$t.length > 0 ? props.formatEUro(props.calcFactureTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t,item.gsx$jourscomplementaires.$t,item.gsx$tjmcomplementaires.$t)) : null}
                                                {item.gsx$type.$t === "2 Facture d'acompte" ? props.formatEUro(props.calcAcompteHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t)) : null}
                                            </td>
                                               </tr>
                                           
                                            
                                           
                                           
                                        {parseFloat(item.gsx$tauxtva.$t)>0?
                                        <>
                                        <tr className="tauxtva">
                                            <th>TVA {item.gsx$tauxtva.$t}%</th>
                                            <td>
                                                {item.gsx$type.$t === "1 Devis" && item.gsx$jours.$t.length > 0 ? props.formatEUro(
                                                    props.calcTVA(
                                                        props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t)
                                                        ,item.gsx$tauxtva.$t)
                                                    ): null}

                                                {item.gsx$type.$t === "3 Facture" && item.gsx$jours.$t.length > 0 ? props.formatEUro(
                                                    props.calcTVA(
                                                    props.calcFactureTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t,item.gsx$jourscomplementaires.$t,item.gsx$tjmcomplementaires.$t)
                                                    ,item.gsx$tauxtva.$t)
                                                    ) : null}
                                                {item.gsx$type.$t === "2 Facture d'acompte" ? props.formatEUro(
                                                    props.calcTVA(
                                                    props.calcAcompteHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t)
                                                    ,item.gsx$tauxtva.$t)
                                                    ) : null}
                                           
                                                
                                            </td>
                                         </tr>
                                        <tr  className="totalttc">
                                            <th>Total TTC</th>
                                            <td>
                                            {item.gsx$type.$t === "1 Devis" && item.gsx$jours.$t.length > 0 ? props.formatEUro(
                                                    props.calcTotalTTC(
                                                        props.calcDevisTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t, item.gsx$tauxremise.$t)
                                                        ,item.gsx$tauxtva.$t)
                                                    ): null}

                                                {item.gsx$type.$t === "3 Facture" && item.gsx$jours.$t.length > 0 ? props.formatEUro(
                                                    props.calcTotalTTC(
                                                    props.calcFactureTotalHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t,item.gsx$jourscomplementaires.$t,item.gsx$tjmcomplementaires.$t)
                                                    ,item.gsx$tauxtva.$t)
                                                    ) : null}
                                                {item.gsx$type.$t === "2 Facture d'acompte" ? props.formatEUro(
                                                    props.calcTotalTTC(
                                                    props.calcAcompteHT(item.gsx$jours.$t, item.gsx$tjm.$t ,item.gsx$tauxremise.$t,item.gsx$tauxacompte.$t)
                                                    ,item.gsx$tauxtva.$t)
                                                    ) : null}
                                              </td>
                                        </tr>
                                        </>
                                        :
                                        <tr>
                                        <td className="notva" colSpan="2">TVA non applicable - Article 293 B du CGI.</td>
                                    </tr>}

                                        
                                        </tfoot>
                                    </table>

                                  

                                  

                                    {item.gsx$type.$t === "1 Devis"?
                                    <><p className="info">
                                    Ce devis est valable 1 mois à compter de sa date d’émission.</p>
                                    <p className="info">
                                    <strong>Pour valider cette commande</strong>, merci de me retourner par courrier ou e-mail une copie de ce document revêtu de votre <strong>signature</strong> et de la mention <strong>"Bon pour accord et exécution"</strong>. <br/><strong>Un acompte de 30% du montant total </strong>de cette commande vous sera demandé.
                                    </p></>:null}
                                   

                                    {item.gsx$type.$t != "1 Devis"?
                                    <>
                                    <p className="info">
                                    <strong>Modalités de paiement : </strong>Chèque, virement bancaire</p>
                                    <p className="info">
                                    <strong>Echéance : </strong>30 jours à compter de la date d'émission</p>
                                    <ul>
                                        <li>rib blblblzzz</li>
                                    </ul>
                                    </>
                                    :null}
                                    <ul className="rib">
                                        <li><span>RIB : </span>
                                        <ul>
                                            <li>
                                                <span>Banque</span>
                                                <span>30003</span>
                                            </li>
                                            <li>
                                                <span>Guichet</span>
                                                <span>01316</span>
                                            </li>
                                            <li>
                                                <span>Compte</span>
                                                <span>00050192333</span>
                                            </li>
                                            <li>
                                                <span>Clé RIB</span>
                                                <span>75</span>
                                            </li>
                                        </ul>
                                        </li>
                                        <li><span>IBAN : </span>FR76 | 3000 | 3013 | 1600 | 0501 | 9233 | 375</li>
                                        <li><span>BIC : </span>SOGEFRPP</li>
                                    </ul>
                                    {item.gsx$type.$t === "1 Devis"?
                                    <>
                                    <div className="signature">
                                    <p><strong>Signature du client</strong><span>Précédée de la mention "Bon pour accord et exécution"</span></p>
                                    <div></div>
                                    
                                    </div> 
                                    </>
                                    :null}

                                    {item.gsx$type.$t ==="1 Devis"&&item.gsx$comentairesbytasks.$t!=""? 
                                    <div className="infobytask">
                                        <p className="title">Détails sur les prestations</p>
                                        {arrayTasks.map((item)=>{return (
                                         item[1]!=""?<p className="comment">{item[1]}</p>:null
                                        )})}

                                      

                                    </div>
                                    :null}

                                    {item.gsx$type.$t ==="1 Devis"?
                                    
                                  <div className="cgv">
                                        <div className="page">1 / 3</div>
                                      <h2 id="conditions-g-n-rales-de-vente">Conditions générales de vente</h2>
<p>La prestation comprend tout ce qui est explicitement listé dans le champ Prestation et le paragraphe Détails sur les prestations. De façon
corollaire, elle ne comprend pas ce qui n’est pas explicité dans ce même champ.</p>
<h3 id="cahier-des-charges">Cahier des charges</h3>
<ol>
<li>La société cliente garantit avoir pris le soin de fournir à Malika Leroy le Cahier des Charges le plus précis possible détaillant la nature et
l’environnement de la commande à réaliser.</li>
<li>Si la société cliente ne fournit pas de cahier des charges à Malika Leroy avant le début de la réalisation de la commande, ou lorsque le
cahier des Charges ne donne pas d’indications ou de recommandations suffisamment précises sur la façon dont doit être abordée le service inclus dans la commande, les deux parties s’accordent sur le fait que le service est laissée à l’interprétation de Malika Leroy.</li>
</ol>
<h3 id="demandes-de-modifications-sur-les-maquettes-ou-pages-web">Demandes de modifications sur les maquettes ou pages web</h3>
<ol>
<li>Par « maquette(s) », on entend au sens du présent contrat, la ou les proposition(s) visuelle(s) finalisée(s) de tout ou partie de la commande.</li>
<li>La société cliente s’engage, à désigner la ou les personnes responsables de formuler en son nom les demandes de modifications sur les
maquettes livrées par Malika Leroy, et à indiquer (par mail ou courrier) l’identité de cette ou de ces personne(s) à Malika Leroy, ceci avant le
début de la réalisation de la commande. Il est entendu par les deux parties qu’il est à la convenance de Malika Leroy de tenir compte d’une
demande de modification(s) émanant d’une personne autre que celle(s) désignée(s) par la société cliente.</li>
<li>Le cas échéant, la société cliente s’engage à formuler ses demandes de modification(s) de façon claire et explicite (par mail ou courrier
exclusivement) dans un délais de quinze jours suivant la livraison de la, ou des maquette(s) à valider. Il est convenu entre les deux parties que
la prise en considération de demande(s) de modification faites par d’autres moyens, notamment oralement, sont laissées à la convenance de
Malika Leroy.</li>
<li>Toute demande de modification émanant de la société cliente faisant état d’une omission, ou d’une erreur de sa part, dans le contenu du
cahier de charges, ou toute demande de la société cliente induisant un ajout ou une suppression de donnée qui affecte le cahier des charges et
les données précisées dans celui-ci sera considérée par les deux parties comme une demande de modification sur l’objet de la commande par
la société cliente.</li>
<li>Toute modification sur l’objet de la commande entraînant des aménagements sur le travail (recherche, conseil, ou exécution) déjà réalisé
par Malika Leroy ou induisant un travail supplémentaire à Malika Leroy, impliqueront une facturation supplémentaire à la rémunération
prévue par ce présent contrat. Les sommes correspondantes au travail déjà effectué par Malika Leroy sont dues par la société cliente et
immédiatement exigibles.</li>
<li>Les demandes de modification(s) entrant dans le cadre de cet article seront évaluées, en temps de réalisation, par Malika Leroy et basées
selon le tarif indicatif présenté dans l’encart « Interventions supplémentaires » de ce présent contrat.</li>
</ol>
<h3 id="validation">Validation</h3>
<ol>
<li>La société cliente s’engage à formuler ses validations de manière claire et explicite par l’envoi d’un Email ou d’un courrier daté et signé à
Malika Leroy.</li>
<li>A défaut, soit d’une validation par la société cliente des livrables constituant le travail de Malika Leroy, soit de demande(s) de
modification(s) sur ces livrables par la société cliente, dans un délai de quinze jours après la livraison du livrable, celui-ci sera considéré comme
validé par le deux parties Le travail réalisé, livré, et tacitement validé, implique que les sommes correspondantes à ce travail sont dues par la
société cliente et immédiatement exigibles par Malika Leroy.</li>
</ol>
<h3 id="facture-et-r-glement">Facture et règlement</h3>
<p>Sauf délai de paiement supplémentaire convenu par accord entre les deux parties et figurant sur la facture, le paiement s’effectue au plus tard
au 30e jour suivant la date de facturation (C. Com. art L. 441-6, al.2 modifié de la loi du 15 mai 2001). Tout retard de paiement pourra donner lieu
à des pénalités de retard exigibles sans rappel, au taux de 10% de la facture totale par mois de retard (Lutte contre les retards de paiement /
article 53 de la Loi NRE ), ainsi qu’à une indemnité forfaitaire de 40€ (C. Com. art. D441-5). Paiements par virement bancaire ou par chèque à
l’ordre de Malika Leroy. Aucun acompte accordé pour règlement comptant.</p>
<h3 id="droits-de-reproduction-et-de-diffusion">Droits de reproduction et de diffusion</h3>
<p>Conformément au CPI (articles L.121-1 à L.121-9) ne seront cédés au client pour l’œuvre décrite que les droits patrimoniaux explicitement
énoncés dans les conditions de cession, à l’exclusion de tout autre, et ce dans les limites y figurant également. Il est rappelé que le droit moral
d’une création (comprenant en autres droit au respect de l’œuvre et droit au respect du nom) reste attaché à son auteur de manière perpétuelle
et imprescriptible. Toute représentation ou reproduction intégrale ou partielle faite sans le consentement de l’auteur ou de ses ayants droit
est illicite, et punie selon les lois relatives au délit de contrefaçon. Il en est de même pour la traduction, l’adaptation ou la transformation,
l’arrangement ou la reproduction par un art ou un procédé quelconque.(Art. L. 122-4 du CPI)</p>
<div className="page second">2 / 3</div>
<h3 id="principes-de-cession">Principes de cession</h3>
<ol>
<li>La totalité de la production et des droits s’y rapportant, objet de la présente commande, demeure la propriété entière et exclusive de Malika
Leroy tant que les factures émises par Malika Leroy ne sont pas payées en totalité par la société cliente, à concurrence du montant global de
la commande et des avenants éventuels conclus en cours de prestation. De façon corollaire, la société cliente deviendra propriétaire de fait des
droits cédés à compter du règlement final et soldant de toutes les factures émises par Malika Leroy dans le cadre de la commande.</li>
<li>La livraison éventuelle des sources ou fichiers de travail relatifs à la présente commande ne se fera qu’en cas de nécessité induite par la
stricte exploitation de l’œuvre prévue dans les conditions de cession ou dans un avenant ultérieur.</li>
</ol>
<h3 id="copyright-et-mention-commerciale">Copyright et mention commerciale</h3>
<p>Malika Leroy se réserve le droit de mentionner sa réalisation pour la société cliente comme référence et de citer des extraits textuels ou
iconographiques des œuvres concernées dans le strict cadre de ses démarches de prospection commerciale, de communication externe et de
publicité. Toute réserve au droit de publicité de Malika Leroy devra être notifiée et négociée avant la signature du devis et mentionnée sur la
facture.</p>
<h3 id="responsabilit-du-client">Responsabilité du client</h3>
<p>La société cliente assume pleine et entière responsabilité des choix réalisés en matière de contenus textuels et iconographiques figurant dans
la réalisation livrée par Malika Leroy, tout comme de l’exploitation qui en sera faite, et notamment de la conformité de cette dernière avec les
réglementations en vigueur. Elle assure également être propriétaire des droits nécessaires à l’exploitation de tous les éléments créatifs textuels et
iconographiques fournis par elle à Malika Leroy dans le cadre de sa mission, et garantit Malika Leroy contre toute plainte tierce relative à la violation des droits de ces éléments.</p>
<div className="pagelast">3 / 3</div>

                                  </div>
                                  :null}

                                </div>
                                <div class="bg-overlay" onClick={(e) => {
                                    props.setModalView(false);
                                }}></div>
                            </div>
                        </main>)
                    })
                : null}
        </>
    )
}